<template>
    <div class="tender-contract">
        <div class="contract-top">
            <el-button class="bigData-btn-contract-save" type="primary" @click="preserveContract" :disabled="!saveButton" v-has="'02010001'" :loading="loadSave">保存</el-button>
            <el-button class="bigData-btn-contract-privilege" type="primary" @click="privilegeClick" :disabled="!privilegeBtn" v-has="'02010002'" :loading="loadSave">特权修改</el-button>
            <el-button class="bigData-btn-contract-copy" v-if="!(form.bidStatus === '00' || form.bidStatus === '10' || form.bidStatus === '20')" type="primary" v-has="'02010077'"
                @click="copyBidFunc">复制</el-button>
        </div>
        <contractInfo ref="contractInfo" :form="form" :siteFormData="siteFormData" :isPrivilege="isPrivilege" :openPerDialog="openPerDialog"></contractInfo>
        <div class="contract-bottom">
            <div class="contract-flie">
                <div class="flie-top">
                    <p class="top-info top">招标文件</p>
                    <!-- <div class="flie-top-right">
                        <div v-if="saveButton" class="contract-select" @click="detail(templateFile)" v-has="'02010003'">
                            <i class="el-icon-upload upload_icon"></i>
                            <span class="load-info">合同模板选择</span>
                        </div>
                        <div v-else class="contract-select" @click="templateSelect" v-has="'02010003'">
                            <i class="el-icon-upload upload_icon"></i>
                            <span class="load-info">合同模板选择</span>
                        </div>
                        <div class="upload">
                            <template v-if="saveButton" v-has="'02010004'">
                                <i class="el-icon-upload upload_icon" @click="upOssFiles"></i>
                                <span class="load-info" @click="upOssFiles">上传</span>
                                <ossBtn v-if="dialogVisible" :visible.sync="dialogVisible" @uploadSuccess="uploadFile"></ossBtn>
                            </template>
                            <template v-if="!saveButton" v-has="'02010004'">
                                <i class="el-icon-upload upload_icon" @click="uploadTip"></i>
                                <span class="load-info" @click="uploadTip">上传</span>
                            </template>
                        </div>
                        <span v-has="'02010005'">
                            <el-button
                                :class="!saveButton ? 'disabled' : 'load-info'"
                                type="text"
                                :disabled="!saveButton"
                                @click="saveList"
                                >保存
                            </el-button>
                        </span>
                    </div> -->
                </div>
                <div style="margin-bottom: 10px;">
                    <template v-if="saveButton" v-has="'02010004'">
                        <el-button type="primary" @click="addNewRow">新增上传文件</el-button>
                        <ossBtn v-if="dialogVisible" :visible.sync="dialogVisible" @uploadSuccess="uploadFile">
                            <!-- 标书文件上传需要有提示 -->
                            <div style="margin-bottom: 10px;color: red;" slot="tips" v-if="formFoot.tableData[uploadFileIdx] && formFoot.tableData[uploadFileIdx].moduleType === '2'">是否已使用最新版标书文件，否则会被登记未按招采管理办法要求操作且考核信用积分</div>
                        </ossBtn>
                    </template>
                    <template v-if="!saveButton" v-has="'02010004'">
                        <el-button type="primary" @click="uploadTip">新增上传文件</el-button>
                    </template>
                    <el-button
                        v-has="'02010005'"
                        :class="!saveButton ? 'disabled' : 'load-info'"
                        type="primary"
                        :disabled="!saveButton"
                        @click="saveList"
                        >保存
                    </el-button>
                </div>
                <el-form :model="formFoot" ref="footForms" :rules="formFoot.footRules">
                    <el-table :data="formFoot.tableData" border>
                        <el-table-column prop="moduleType" label="附件类型" align="center" width="150">
                            <template slot-scope="scope">
                                <div v-if="scope.$index <= 3"><span style="color: red;">*</span>{{ scope.row._moduleType }}</div>
                                <el-select
                                    v-else
                                    v-model="scope.row.moduleType"
                                    placeholder="请选择"
                                    @change="fixedChange(scope.row)">
                                    <el-option
                                        v-for="item in fileOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        :disabled="item.disabled">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fixedTemplateText" label="是否固定模板" align="center" width="150"></el-table-column>
                        <el-table-column prop="_extStr1" label="是否主合同" align="center" width="150">
                            <!-- <template slot-scope="scope">
                                <el-form-item
                                    :prop="'tableData.' + scope.$index + '.extStr1'"
                                    :rules="formFoot.footRules.extStr1">
                                    <MSelect
                                        :optionNum="'BID_YES_NO'"
                                        :value="scope.row.extStr1"
                                        :filterable="true"
                                        @input="getExtStr1(scope.row, arguments)"
                                        :disabled="scope.row.moduleType !== '1' || (scope.row.moduleType === '1' && scope.row.fixedTemplate === '1')"
                                    ></MSelect>
                                </el-form-item>
                            </template> -->
                        </el-table-column>
                        <el-table-column prop="fileName" label="上传附件名称" show-overflow-tooltip align="center"></el-table-column>
                        <el-table-column prop="updateTime" label="上传时间" align="center"></el-table-column>
                        <el-table-column label="操作" align="center" width="290">
                            <template slot-scope="scope">
                                <span class="btn-del" v-if="scope.row.id">
                                    <el-button type="text" @click="previewBtn(scope.row)">预览</el-button>
                                </span>
                                <!-- 不是(应标文件，回执文件 && 固定模板) 显示上传按钮 -->
                                <span v-has="'02010004'" class="btn-del" v-if="!(['3', '4'].includes(scope.row.moduleType) && scope.row.fixedTemplate === '1')">
                                    <el-button :loading="scope.row.loading" type="text" @click="upOssFiles(scope.$index)">上传</el-button>
                                </span>
                                <!-- 标书文件 显示【最新模板下载】 -->
                                <span class="btn-del" v-if="['2'].includes(scope.row.moduleType)">
                                    <el-button style="color: red;" type="text" @click="newTempDownload">最新模板下载</el-button>
                                </span>
                                <!-- 第4条 显示【合同模板选择】 -->
                                <span v-has="'02010003'" class="btn-del" v-if="scope.$index === 3 && saveButton">
                                    <el-button :loading="scope.row.loading" type="text" @click="detail(templateFile, scope.$index)">合同模板选择</el-button>
                                </span>
                                <!-- 第4条 显示【合同模板选择】 -->
                                <span v-has="'02010003'" class="btn-del" v-if="scope.$index === 3 && !saveButton">
                                    <el-button type="text" @click="templateSelect">合同模板选择</el-button>
                                </span>
                                <span v-has="'02010064'" class="btn-del" v-if="scope.row.id">
                                    <el-button type="text" @click="downloadBtn(scope.row)">下载</el-button>
                                </span>
                                <!-- 前4条不显示【删除】 -->
                                <span v-has="'02010065'" class="btn-del" v-if="saveButton || isPrivilege">
                                    <el-button type="text" v-if="scope.$index >= 4"
                                        @click="delFileBtn(scope.row, scope.$index)">删除</el-button>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
        </div>
        <groupDialog
            :checkPerStatus="openPerDialog"
            @perDialog="overPerDialog"
            @closePerDialog="closePerDialog"
            v-if="openPerDialog.showDialog"
        ></groupDialog>
        <advance-dialog
            ref="advanceDialog"
            @confirm="detaliSearchSure"
        ></advance-dialog>
        <privilegeDialog
            v-if="showPrivilegeDialog"
            :showPrivilegeDialog.sync="showPrivilegeDialog"
            @privilegeConfirm="privilegeConfirm"
        ></privilegeDialog>
        <copyDialog :showCopyDialog.sync="showCopyDialog" :formParent="form"></copyDialog>
    </div>
</template>
<script>
import { downloadTemplate } from '../../../../api/bidScheme.js';
import tenderContract from './tenderContractCode/tenderContract.js';
export default tenderContract;
</script>
<style  lang='less'>
@import url("./tenderContractCode/tenderContract.less");
</style>
